module.exports = __webpack_public_path__ + "img/中国搜索_03.a009a9bb.jpg";